// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import Lang from './helpers/lang'
import Config from './helpers/config'

// non-vuecidity components
import CategotyList from './components/category-list'
import ApiGrid from './components/api-grid'
import AjaxPanel from './components/ajax-panel'
import ExampleTitle from './components/example-title'
import SearchBar from './components/search-bar'
import ToolbarLinks from './components/toolbar-links'
import ProgressTester from './components/progress-tester'
import PatreonButton from './components/patreon-button'
import SupportPanel from './components/support-panel'

import Vuecidity from 'vuecidity'
import '../node_modules/vuecidity/dist/lib/vuecidity.min.css'
import './App.css'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(Vuecidity)

Vue.use(CategotyList)
Vue.use(ApiGrid)
Vue.use(AjaxPanel)
Vue.use(ExampleTitle)
Vue.use(SearchBar)
Vue.use(ToolbarLinks)
Vue.use(ProgressTester)
Vue.use(PatreonButton)
Vue.use(SupportPanel)

const store = new Vuex.Store({
  state: {
    lang: Lang,
    config: Config,
    events: {
      ready: 'ready',
      pageReady: 'page-ready',
      showCodeDialog: 'show-code-dialog',
      ajaxStart: 'ajax-start',
      ajaxEnd: 'ajax-end',
      exampleLoading: 'example-loading',
      exampleLoaded: 'example-loading',
      hasApi: 'has-api'
    },
    siteDetails: null,
    categoryColor: 'primary',
    apiEndpoint: window.location.href.indexOf('localhost') > -1 ? 'http://vuecidity.wemakesites.local' : '',
    npmVersion: window.location.href.indexOf('localhost') > -1 ? 'http://vuecidity.wemakesites.local/npm.php' : '/npm.php',
    pages: {},
    vuecidityVersion: null
  },
  mutations: {
    storePage (state, data) {
      if (data && data.slug) {
        state.pages[data.slug] = data
      }
    },
    setCategoryColor (state, color) {
      state.categoryColor = color
    },
    storeSiteDetails (state, siteDetails) {
      state.siteDetails = siteDetails
    },
    setVuecidityVersion (state, version) {
      state.vuecidityVersion = version
    }
  },
  getters: {
    page: (state) => (slug) => {
      return state.pages[slug]
    },
    langKey: (state) => (key) => {
      return state.lang[key]
    },
    categoryColor: state => {
      return state.categoryColor
    },
    apiEndpoint: state => {
      return state.apiEndpoint
    },
    siteDetails: state => {
      return state.siteDetails
    },
    siteTitle: state => {
      return state.siteDetails ? state.siteDetails.title : ''
    },
    vuecidityVersion: state => {
      return state.vuecidityVersion
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js